import {
  Container,
  ContentContainer,
  Id,
  Date,
  Description,
  Status,
  OpenTicketDetailIcon,
} from './SingleTicket.styled';
import { SingleTicketProps } from './SingleTicket.types';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';
import { StatusBadge } from 'src/components/Tickets/common/StatusBadge/StatusBadge';

export const SingleTicket = ({
  createdOn,
  description,
  id,
  status,
  axsTicketID,
  owner,
}: SingleTicketProps) => {
  const { toggleTicketDetails } = useServiceDeskContext();

  return (
    <Container>
      <ContentContainer>
        <Id>{id}</Id>
        <Date>{createdOn}</Date>
        <Description>{description}</Description>
        <Status>{status && <StatusBadge status={status} />}</Status>
        <OpenTicketDetailIcon
          onClick={() => toggleTicketDetails(axsTicketID, owner, true)}
        />
      </ContentContainer>
    </Container>
  );
};
